module.exports = __webpack_public_path__ + "static/media/lucas_bischoff.c4964a19.jpg";